export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "olimp-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "olimp-themeWrapLive" */'./LiveThemeImporter'),
  },
};
